module.exports = __webpack_public_path__ + "img/magento-vs-woocommerce-showdown.8ad1eda3.jpeg";